import {AGRISMART2, ALERTS, DEVICES, get, PARCELS} from "./Client";
import { sortDevices } from "./ProjectService";
import {useSelector} from "react-redux";
import {useQuery} from "react-query";


export function useGetAllDevices() {
	const { status, data, error } = useQuery(['devices'], () =>
		get(`${AGRISMART2}/${DEVICES}`, { params: { detailed: false } })
	);
	return { status, devices: data || [], error };
}

export function useGetDevices() {
	let project = useSelector(store => store.session.project);
	let params = project ? {pid:project.id} : null;
	const {status, data, error} = useQuery(['devices', params], () =>
		get(`${AGRISMART2}/${DEVICES}`, {params}), {
			enabled: !!project,
			select: data => data.sort((a, b) => sortDevices(a, b)),
		}
	);
	return {status, devices: data || [], error};
}

export function useGetParcels() {
	let project = useSelector(store => store.session.project);
	let params = project ? {project:project.id} : null;
	const {status, data, error} = useQuery(['parcels', params], () =>
		get(`${AGRISMART2}/${PARCELS}`, {params}),
		{enabled: !!project}
	);
	return {status, parcels: data || [], error};
}

export function useGetAlerts(open) {
	let project = useSelector(store => store.session.project);
	let params = project ? {project:project.id} : null
	if(open !== undefined) params.open = open
	const {status, data, error} = useQuery(['alerts', params], () =>
		get(`${AGRISMART2}/${ALERTS}`, {params}),
		{enabled: !!project}
	);
	return {status, alerts: data || [], error};
}

export function useGetSensors() {
	const {status, data, error} = useQuery('sensors', () => get(`${AGRISMART2}/sensors`))
	return {status, sensors: data || [], error}
}

export function useGetConfigurations() {
	const {status, data, error} = useQuery('configurations', () => get(`${AGRISMART2}/configurations`))
	return {status, configurations: data || [], error}
}

export function getTodayData(device) {
	return get(`${AGRISMART2}/devices/${device}/data/today`).then(elaborateData)
}

export function getWeeklyData(device) {
	return get(`${AGRISMART2}/devices/${device}/data/week`).then(elaborateData)
}

export function getMonthlyData(device) {
	return get(`${AGRISMART2}/devices/${device}/data/month`).then(elaborateData)
}

export function getCustomData(device, start, end) {
	return get(`${AGRISMART2}/devices/${device}/data/custom`, {params:{start,end}}).then(elaborateData)
}

export function getStatisticalData(device, start, end) {
	return get(`${AGRISMART2}/devices/${device}/statistics/daily`, {params:{start,end}})
}

export function getStatisticalCalculation(device, start, end) {
	return get(`${AGRISMART2}/devices/${device}/statistics/calculation`, {params:{start,end}})
}

/**
 * Controlla che i valori nei dati della centralina siano numeri regolari
 * @param {Array} data lista messaggi
 * @returns 
 */
function elaborateData(data) {
	data.forEach(d => {
		for (let key in d.paramMap) {
			if (d.paramMap.hasOwnProperty(key)) {
				if (isNaN(d.paramMap[key])) d.paramMap[key] = null
			}
		}
	})
	return data
}
